export default __webpack_public_path__ + "static/media/vegan.3df9aa85.png";